import { useState } from 'react';

// Declarar a função gtag_report_conversion do Google Ads
declare global {
  interface Window {
    gtag_report_conversion: (url?: string) => boolean;
  }
}

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: '',
  });
  const [charCount, setCharCount] = useState(0);

  const handleWhatsApp = () => {
    // Registrar conversão do Google Ads antes de abrir o WhatsApp
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
    window.open('https://wa.me/5519981868997', '_blank');
  };

  const handleCall = () => {
    // Registrar conversão do Google Ads antes de fazer a ligação
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
    window.location.href = 'tel:+5519981868997';
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === 'message') {
      setCharCount(value.length);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name || !formData.phone || !formData.service) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    if (formData.message.length > 500) {
      alert('A mensagem não pode exceder 500 caracteres.');
      return;
    }

    // Montar mensagem para WhatsApp
    let message = `Olá! Gostaria de solicitar um orçamento:\n\n`;
    message += `*Nome:* ${formData.name}\n`;
    message += `*Telefone:* ${formData.phone}\n`;
    if (formData.email) {
      message += `*E-mail:* ${formData.email}\n`;
    }
    message += `*Serviço:* ${formData.service}\n`;
    if (formData.message) {
      message += `*Mensagem:* ${formData.message}`;
    }

    const whatsappUrl = `https://wa.me/5519981868997?text=${encodeURIComponent(message)}`;
    
    // Registrar conversão do Google Ads antes de abrir o WhatsApp
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
    
    window.open(whatsappUrl, '_blank');

    // Limpar formulário
    setFormData({ name: '', phone: '', email: '', service: '', message: '' });
    setCharCount(0);
  };

  return (
    <section id="contato" className="py-20 bg-gradient-to-br from-blue-600 to-green-600">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 text-white">
          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-whatsapp-line text-green-500 text-3xl"></i>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Conte com a melhor Desentupidora
          </h2>
          <h3 className="text-3xl font-semibold mb-8">Chegamos em até 30 Minutos</h3>
          <button
            onClick={handleWhatsApp}
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105 flex items-center justify-center space-x-2 mx-auto whitespace-nowrap shadow-lg"
          >
            <i className="ri-whatsapp-line"></i>
            <span>Chame pelo WhatsApp</span>
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-white">
            <h4 className="text-2xl font-bold mb-6">
              Conte conosco para resolver qualquer tipo de entupimento.
            </h4>
            <h5 className="text-xl font-semibold mb-8">ATENDIMENTO 24 HORAS</h5>

            <div className="text-center mb-8">
              <div className="w-32 h-32 bg-white/20 rounded-full flex items-center justify-center mx-auto animate-pulse">
                <i className="ri-tools-line text-6xl"></i>
              </div>
            </div>

            <div className="space-y-4">
              <button
                onClick={handleCall}
                className="w-full flex items-center justify-center space-x-3 bg-white/20 backdrop-blur-sm rounded-lg p-4 hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-2xl"></i>
                <span className="text-lg font-semibold">(19) 98186-8997</span>
              </button>
              <button
                onClick={handleWhatsApp}
                className="w-full flex items-center justify-center space-x-3 bg-green-500/80 backdrop-blur-sm rounded-lg p-4 hover:bg-green-500 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span className="text-lg font-semibold">(19) 98186-8997</span>
              </button>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <h4 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              Solicite seu Orçamento Grátis
            </h4>

            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Nome Completo *</label>
                  <input
                    required
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm"
                    placeholder="Seu nome completo"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    Telefone/WhatsApp *
                  </label>
                  <input
                    required
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm"
                    placeholder="(19) 99999-9999"
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-2">E-mail</label>
                <input
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm"
                  placeholder="seu@email.com"
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-2">Tipo de Serviço *</label>
                <div className="relative">
                  <select
                    name="service"
                    required
                    value={formData.service}
                    onChange={handleChange}
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors appearance-none text-sm"
                  >
                    <option value="">Selecione o serviço desejado</option>
                    <option value="Desentupimento de Pias">Desentupimento de Pias</option>
                    <option value="Desentupimento de Vasos">Desentupimento de Vasos</option>
                    <option value="Desentupimento de Ralos">Desentupimento de Ralos</option>
                    <option value="Desentupimento de Canos">Desentupimento de Canos</option>
                    <option value="Desentupimento de Esgotos">Desentupimento de Esgotos</option>
                    <option value="Limpeza de Caixas de Gordura">
                      Limpeza de Caixas de Gordura
                    </option>
                    <option value="Limpeza de Fossas">Limpeza de Fossas</option>
                    <option value="Hidrojateamento">Hidrojateamento</option>
                    <option value="Outro serviço">Outro serviço</option>
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2">Mensagem</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors resize-none text-sm"
                  placeholder="Descreva seu problema ou dúvida (máximo 500 caracteres)"
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">{charCount}/500 caracteres</div>
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-600 to-green-600 text-white px-6 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Solicitar Orçamento Grátis
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;